import { useEffect, useState } from 'react';
import { fetchOrderFifoPreview, OrderFifoPreviewLine } from '../api/orderProductsApi';

export function useOrderFifoPreview(orderId: string, products: readonly unknown[], enabled: boolean) {
  const request = JSON.stringify(products);
  const [state, setState] = useState<{ orderId: string; request: string; lines: OrderFifoPreviewLine[]; failed: boolean }>();
  useEffect(() => {
    if (!enabled) return;
    let active = true;
    const timer = setTimeout(() => {
      fetchOrderFifoPreview(orderId, JSON.parse(request)).then(
        lines => { if (active) setState({ orderId, request, lines, failed: false }); },
        () => { if (active) setState({ orderId, request, lines: [], failed: true }); },
      );
    }, 250);
    return () => { active = false; clearTimeout(timer); };
  }, [orderId, request, enabled]);
  return {
    lines: enabled && (state?.orderId === orderId && state?.request === request) ? state.lines : [],
    failed: enabled && (state?.orderId === orderId && state?.request === request) && state.failed,
  };
}
